import { __decorate } from "tslib";
import Modal from "@/components/Modal.vue";
import Money from '@/components/Money.vue';
import FastMap from '@/components/Teeth/Fast.vue';
import ToothParts from '@/components/Tooth/Parts.vue';
import User from '@/components/User.vue';
import xrayType from '@/filters/xrays';
import ModalMixin from "@/mixins/modal-mixin";
import ru from "@/Pages/People/Customer/Header043/ru.vue";
import uz from "@/Pages/People/Customer/Header043/uz.vue";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapActions, mapGetters } from 'vuex';
//@ts-ignore
import { conditionsArray } from '@/filters/condition.js';
import dentalCharts from "@/components/dentalCharts";
import CustomSwitch from "@/components/CustomSwitch.vue";
let ProfileCardModal = class ProfileCardModal extends Mixins(ModalMixin) {
    id;
    customerId;
    getCompanyFromStore;
    getCustomerFromStore;
    findExam;
    findXraysFromStore;
    queryExam;
    queryXrays;
    title = 'Print Plan';
    childTeethMap = true;
    adultTeethMap = true;
    get settingsCountry() {
        const settings = this.company.settings;
        const existingHeaders = ['uz', 'ru'];
        return (existingHeaders.includes(settings.country || '')) ? settings.country : false;
    }
    get childTeeth() {
        const chart = dentalCharts.find((item) => {
            return item.value === this.$settings.dentalChart;
        });
        if (!chart)
            return;
        return chart.chart.kid;
    }
    get adultTeeth() {
        const chart = dentalCharts.find((item) => {
            return item.value === this.$settings.dentalChart;
        });
        if (!chart)
            return;
        return chart.chart.adult;
    }
    get isKid() {
        const age = this.$moment().diff(this.customer.birth_date, 'years');
        return age <= 7;
    }
    get queryParams() {
        const params = {
            query: {
                $sort: {
                    createdAt: -1
                },
                customerId: this.$route.params.id,
            }
        };
        return params;
    }
    get company() {
        return this.getCompanyFromStore("mine");
    }
    get customer() {
        return this.getCustomerFromStore(this.customerId);
    }
    get exam() {
        return this.findExam(this.queryParams).data[0];
    }
    get otherFields() {
        const idx = this.company.fields.findIndex(row => row.location.indexOf('exam'));
        return this.company.fields[idx] || {};
    }
    get exams() {
        const exams = this.findExam(this.queryParams).data;
        exams.forEach(exam => {
            if (!exam.treatments)
                return;
            exam.treatments.forEach(treatment => {
                let a = this.getTreatmentData(treatment);
                treatment.manipulations = a.manipulations;
                // @ts-ignore
                treatment.products = a.products;
            });
        });
        return exams;
    }
    get xrays() {
        return this.findXraysFromStore(this.queryParams).data;
    }
    getTreatmentData(treatment) {
        const result = {
            manipulations: [],
            products: [],
        };
        if (treatment.manipulations) {
            const manipulations = treatment.manipulations.filter((item) => item !== null);
            result.manipulations.push(...manipulations);
        }
        if (treatment.bundle) {
            treatment.bundle.forEach(item => {
                if (item.type == 'service' && item.service) {
                    let childs = this.getTreatmentData(item.service);
                    result.products = [...result.products, ...childs.products];
                    result.manipulations = [...result.manipulations, ...childs.manipulations];
                }
                else if (item.type == 'product' && item.product) {
                    result.products.push({
                        ...item.product,
                        quantity: item.quantity
                    });
                }
            });
        }
        return result;
    }
    hidden() {
        const $printSection = document.getElementById("printSection");
        if ($printSection) {
            $printSection.remove();
        }
    }
    shown() {
        this.queryExam(this.queryParams);
        this.queryXrays(this.queryParams);
    }
    print() {
        const domClone = document.getElementById("printContent").cloneNode(true);
        var $printSection = document.getElementById("printSection");
        if (!$printSection) {
            $printSection = document.createElement("div");
            $printSection.id = "printSection";
            document.body.appendChild($printSection);
        }
        $printSection.innerHTML = "";
        $printSection.appendChild(domClone);
        window.print();
    }
    close() {
        this.$root.$emit('bv::hide::modal', this.id);
    }
    removeExtraSpace(text) {
        if (!text)
            return;
        return text.replace(/\s+$/, '');
    }
    conditionLabel(condition) {
        let conditions = this.$copy(conditionsArray());
        let obj = conditions.find((o) => o.value === condition);
        if (!obj)
            return;
        return this.$t(`conditionCodes.${obj.abbr}`);
    }
    getCurrentExam(tooth, examMap) {
        let exams = [];
        examMap.map((el) => {
            if (el.tooth === tooth)
                exams.push(this.conditionLabel(el.diagnosis));
        });
        return exams.join(', ');
    }
    doneManipulations(exam) {
        const manipulations = new Set();
        exam.treatments.forEach((treatment) => {
            if (!treatment.manipulations.length) {
                manipulations.add(treatment);
            }
            treatment.manipulations.filter((item) => item !== null)
                .forEach((manipulation) => manipulations.add(manipulation));
        });
        return Array.from(manipulations).filter(manipulation => manipulation);
    }
    usedProducts(exam) {
        return exam.treatments.map((treatment) => this.getTreatmentData(treatment)).flatMap(data => data.products);
    }
    allODBs(exam) {
        // @ts-ignore Ignore it due compatibility issues
        const odbs = exam.treatments.filter((treatment) => treatment.odb)
            .flatMap((treatment) => treatment.odb) || [];
        const set = new Set(odbs);
        exam.odb.forEach(odb => set.add(odb));
        return Array.from(set);
    }
    allCDBs(exam) {
        // @ts-ignore Ignore it due compatibility issues
        const cdbs = exam.treatments.filter((treatment) => treatment.cdb)
            .flatMap((treatment) => treatment.cdb) || [];
        const set = new Set(cdbs);
        exam.cdb.forEach(cdb => set.add(cdb));
        return Array.from(set);
    }
    allDiagnosises(exam) {
        // @ts-ignore Ignore it due compatibility issues
        const diagnosis = exam.treatments.filter((treatment) => treatment.diagnosisFinal).flatMap((treatment) => treatment.diagnosisFinal) || [];
        const set = new Set(diagnosis);
        exam.diagnosisFinal.forEach(diagnosisFinal => set.add(diagnosisFinal));
        return Array.from(set);
    }
    getXrayTypeLabel(xray) {
        return xrayType(xray.type).label;
    }
};
__decorate([
    Prop({ type: String, required: true })
], ProfileCardModal.prototype, "id", void 0);
__decorate([
    Prop({ type: String, required: true })
], ProfileCardModal.prototype, "customerId", void 0);
ProfileCardModal = __decorate([
    Component({
        name: 'print-options',
        components: {
            CustomSwitch,
            User,
            Modal,
            Money,
            FastMap,
            ToothParts,
            uz,
            ru
        },
        computed: {
            ...mapGetters('customers', {
                getCustomerFromStore: 'get'
            }),
            ...mapGetters('exam', {
                getExamFromStore: 'get',
                findExam: 'find',
            }),
            ...mapGetters('xrays', {
                findXraysFromStore: 'find',
            }),
            ...mapGetters('my-company', {
                getCompanyFromStore: 'get'
            }),
        },
        methods: {
            ...mapActions('exam', { queryExam: 'find' }),
            ...mapActions('xrays', { queryXrays: 'find' }),
        }
    })
], ProfileCardModal);
export default ProfileCardModal;
